import React, { useEffect, useRef } from 'react'
import './Ourvission.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Ourvisson = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 85%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        }).to(buttonRef.current, {
            rotateY: 360,
            duration: 0.8,
            ease: "power2.inOut",
        });
    }, []);

    return (
        <>
            <section className='ourvisionmaniprnt'>
                <div className="custom-container">
                    <div className="visionprnt">
                        <div className="aboutusmission">
                            {/* <h5 ref={buttonRef}>Vision</h5> */}
                            <div className="aboutusmissioncnt">
                                <h2 ref={textRef}>Our Vision</h2>
                                <p ref={paraRef}>To be the leading platform that merges Web3 technology with everyday usability, enabling everyone to connect, transact, and engage freely without compromise.</p>
                            </div>
                        </div>
                        <div className="visionimgleft">
                            <img className='img-fluid' src="\assets\Aboutus\visionrightimg.png" alt="img" />
                        </div>
                    </div>
                </div>
            </section></>
    )
}

export default Ourvisson